export default {
  error: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
  },
};
